import _ from 'lodash';
import {
  FETCH_DOCUMENTS_SUCCESS,
  UPDATE_DOCUMENT,
  FETCH_DOCUMENT,
  CREATE_ADDENDA,
  DESTROY_ADDENDA,
} from '../actions/types';

const initialState = {
  documents: {}, // stores multiple documents by id
  document: {}, // can still hold the "current" document if needed
};

export default function (state = initialState, action) {
  switch (action.type) {
    // Load multiple documents
    case FETCH_DOCUMENTS_SUCCESS: {
      const documentsById = _.keyBy(action.payload.data, 'id'); // index by id
      return {
        ...state,
        documents: { ...state.documents, ...documentsById },
      };
    }

    // Load a single document
    case FETCH_DOCUMENT: {
      const doc = action.payload.data;

      if (doc.type_of === 'private_note') {
        return {
          ...state,
          privateNote: doc,
        };
      }

      return {
        ...state,
        documents: { ...state.documents, [doc.id]: doc },
        document: doc, // optional: keep as "current document"
      };
    }

    case CREATE_ADDENDA: {
      const newAddendum = action.payload.data;
      const parentId = newAddendum.parent_note_id;

      const parentDoc = state.documents[parentId];
      if (!parentDoc) return state;

      return {
        ...state,
        documents: {
          ...state.documents,
          [parentId]: {
            ...parentDoc,
            addenda: [...(parentDoc.addenda || []), newAddendum],
          },
        },
        document:
          state.document.id === parentId
            ? {
                ...state.document,
                addenda: [...(state.document.addenda || []), newAddendum],
              }
            : state.document,
      };
    }

    // Update a single document
    case UPDATE_DOCUMENT: {
      const updatedDoc = action.payload.data;
      // Check if this update is for an addendum
      if (updatedDoc.parent_note_id) {
        const parentId = updatedDoc.parent_note_id; // reference to main document
        const parentDoc = state.documents[parentId];

        if (!parentDoc) return state;

        // Update only the targeted addendum
        const updatedAddenda = (parentDoc.addenda || []).map(a =>
          a.id === updatedDoc.id ? { ...a, ...updatedDoc } : a,
        );

        return {
          ...state,
          documents: {
            ...state.documents,
            [parentId]: { ...parentDoc, addenda: updatedAddenda },
          },
          document:
            state.document.id === parentId
              ? { ...state.document, addenda: updatedAddenda }
              : state.document,
        };
      }

      // Otherwise update the document itself
      return {
        ...state,
        documents: { ...state.documents, [updatedDoc.id]: updatedDoc },
        document:
          state.document.id === updatedDoc.id ? updatedDoc : state.document,
      };
    }

    case DESTROY_ADDENDA: {
      const addendumId = action.payload.data.id;
      const parentId = action.payload.data.parent_note_id;

      const parentDoc = state.documents[parentId];
      if (!parentDoc) return state;

      const filteredAddenda = (parentDoc.addenda || []).filter(
        a => a.id !== addendumId,
      );

      return {
        ...state,
        documents: {
          ...state.documents,
          [parentId]: { ...parentDoc, addenda: filteredAddenda },
        },
        document:
          state.document.id === parentId
            ? { ...state.document, addenda: filteredAddenda }
            : state.document,
      };
    }

    default:
      return state;
  }
}
